/**
 * Handled HTTP response types from the API
 */
export const HttpResponseType = {
	Json: 'json',
	Blob: 'blob',
	ArrayBuffer: 'arraybuffer',
	Text: 'text',
};

// Freeze it so it can't be accidentally modified (similar to enum behavior)
Object.freeze(HttpResponseType);
